import { Palette } from 'config';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 32px;
`;

export const Title = styled.p`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border-radius: 4px;
  background: ${Palette.PrimaryGray._200};
  padding: 4px;
`;

export const Description = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const Macros = styled.div`
  display: flex;
  gap: 8px;
`;

export const MacrosList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FoterStr = styled.p`
  margin-top: 16px;
  margin-bottom: 32px;
  color: #64748b;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  a {
    color: ${Palette.Primary._500};
    text-decoration: none;
    margin-left: 3px;
  }
`;
